/**
 * Controls the offset when we start loading the more from brand carousel
 */
export const ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828 = 'ADJUST_MORE_FROM_BRAND_FE_LOADING_OFFSET_240828';
